
export default class Vector3 {
	constructor (x, y, z) {
		this.x = x;
		this.y = y;
		this.z = z;
	}

	distance (vec3) {
		var dx = vec3.x - this.x;
		var dy = vec3.y - this.y;
		var dz = vec3.z - this.z;
		return Math.sqrt(dx * dx + dy * dy + dz * dz);
	}

	// distanceSquared (vec3) {
	// 	var dx = vec3.x - this.x;
	// 	var dy = vec3.y - this.y;
	// 	var dz = vec3.z - this.z;
	// 	return dx * dx + dy * dy + dz * dz;
	// }

	set (x, y, z) {
		this.x = x;
		this.y = y;
		this.z = z;
		return this;
	}

	// setArray (arr) {
	// 	this.x = arr[0];
	// 	this.y = arr[1];
	// 	this.z = arr[2];
	// 	return this;
	// }

	setVector3 (vec3) {
		this.x = vec3.x;
		this.y = vec3.y;
		this.z = vec3.z;
		return this;
	}

	// Operations modifying the vector

	// addScalar (s) {
	// 	this.x += s;
	// 	this.y += s;
	// 	this.z += s;
	// 	return this;
	// }

	// subtractScalar (s) {
	// 	this.x -= s;
	// 	this.y -= s;
	// 	this.z -= s;
	// 	return this;
	// }

	multiplyScalar (s) {
		this.x *= s;
		this.y *= s;
		this.z *= s;
		return this;
	}

	// divideScalar (s) {
	// 	this.x /= s;
	// 	this.y /= s;
	// 	this.z /= s;
	// 	return this;
	// }

	add (vec3) {
		this.x += vec3.x;
		this.y += vec3.y;
		this.z += vec3.z;
		return this;
	}

	subtract (vec3) {
		this.x -= vec3.x;
		this.y -= vec3.y;
		this.z -= vec3.z;
		return this;
	}

	multiply (vec3) {
		this.x *= vec3.x;
		this.y *= vec3.y;
		this.z *= vec3.z;
		return this;
	}

	divide (vec3) {
		this.x /= vec3.x;
		this.y /= vec3.y;
		this.z /= vec3.z;
		return this;
	}

	normalize () {
		var length = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
		if (length === 0) { this.x = 1; length = 1; }

		this.x /= length;
		this.y /= length;
		this.z /= length;
		return this;
	}

	// negate () {
	// 	this.x = -this.x;
	// 	this.y = -this.y;
	// 	this.z = -this.z;
	// 	return this;
	// }

	// multiplyMatrix3x3 (mat3) {
	// 	var m = mat3._m;
	// 	var x = this.x;
	// 	var y = this.y;
	// 	var z = this.z;

	// 	this.x = x * m[0] + y * m[1] + z * m[2];
	// 	this.y = x * m[3] + y * m[4] + z * m[5];
	// 	this.z = x * m[6] + y * m[7] + z * m[8];
	// 	return this;
	// }

	// multiplyMatrix4x4 (mat4) {
	// 	var m = mat4._m;
	// 	var x = this.x;
	// 	var y = this.y;
	// 	var z = this.z;

	// 	this.x = x * m[0] + y * m[1] + z * m[2];
	// 	this.y = x * m[4] + y * m[5] + z * m[6];
	// 	this.z = x * m[8] + y * m[9] + z * m[10];
	// 	return this;
	// }

	invert () {
		this.x = 1 / this.x;
		this.y = 1 / this.y;
		this.z = 1 / this.z;
		return this;
	}

	rotate (rotation, vec3Axis) {
		if (rotation === 0) {
			return this;
		}

		// TODO
		throw new Error('[Vector3.rotate] Not implemented yet!', vec3Axis);
	}

	rotateX (rotation) {
		if (rotation === 0) {
			// No rotation
			return this;
		}

		var sin = Math.sin(rotation);
		var cos = Math.cos(rotation);

		var y = this.y;
		var z = this.z;

		this.y = cos * y - sin * z;
		this.z = cos * z + sin * y;
		return this;
	}

	rotateY (rotation) {
		if (rotation === 0) {
			// No rotation
			return this;
		}

		var sin = Math.sin(rotation);
		var cos = Math.cos(rotation);

		var x = this.x;
		var z = this.z;

		this.x = cos * x + sin * z;
		this.z = cos * z - sin * x;
		return this;
	}

	rotateZ (rotation) {
		if (rotation === 0) {
			// No rotation
			return this;
		}

		var sin = Math.sin(rotation);
		var cos = Math.cos(rotation);

		var x = this.x;
		var y = this.y;

		this.x = cos * x - sin * y;
		this.y = cos * y + sin * x;
		return this;
	}

	unrotateX (rotation) { return this.rotateX(-rotation); }
	unrotateY (rotation) { return this.rotateY(-rotation); }
	unrotateZ (rotation) { return this.rotateZ(-rotation); }

	// Operations creating a new vector

	// additionScalar (s) {
	// 	return new Vector3(this.x + s, this.y + s, this.z + s);
	// }

	// subtractionScalar (s) {
	// 	return new Vector3(this.x - s, this.y - s, this.z - s);
	// }

	multiplicationScalar (s) {
		return new Vector3(this.x * s, this.y * s, this.z * s);
	}

	// divisionScalar (s) {
	// 	return new Vector3(this.x / s, this.y / s, this.z / s);
	// }

	addition (vec3) {
		return new Vector3(this.x + vec3.x, this.y + vec3.y, this.z + vec3.z);
	}

	subtraction (vec3) {
		return new Vector3(this.x - vec3.x, this.y - vec3.y, this.z - vec3.z);
	}

	multiplication (vec3) {
		return new Vector3(this.x * vec3.x, this.y * vec3.y, this.z * vec3.z);
	}

	division (vec3) {
		return new Vector3(this.x / vec3.x, this.y / vec3.y, this.z / vec3.z);
	}

	negation () {
		return new Vector3(-this.x, -this.y, -this.z);
	}

	normalization () {
		var length = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
		if (length === 0) { this.x = 1; length = 1; }
		return new Vector3(this.x / length, this.y / length, this.z / length);
	}

	multiplicationMatrix3x3 (mat3) {
		var m = mat3._m;
		var x = this.x * m[0] + this.y * m[1] + this.z * m[2];
		var y = this.x * m[3] + this.y * m[4] + this.z * m[5];
		var z = this.x * m[6] + this.y * m[7] + this.z * m[8];
		return new Vector3(x, y, z);
	}

	multiplicationMatrix4x4 (mat4) {
		var m = mat4._m;
		var x = this.x * m[0] + this.y * m[1] + this.z * m[2];
		var y = this.x * m[5] + this.y * m[5] + this.z * m[6];
		var z = this.x * m[8] + this.y * m[9] + this.z * m[10];
		return new Vector3(x, y, z);
	}

	rotation (rotation, vec3Axis) {
		if (rotation === 0) {
			return new Vector3(this.x, this.y, this.z);
		}

		// TODO
		throw new Error('[Vector3.rotation] Not implemented yet!', vec3Axis);
	}

	inverse () {
		return new Vector3(1 / this.x, 1 / this.y, 1 / this.z);
	}

	rotationX (rotation) {
		if (rotation === 0) {
			// No rotation
			return new Vector3(this.x, this.y, this.z);
		}

		var sin = Math.sin(rotation);
		var cos = Math.cos(rotation);

		var y = cos * this.y - sin * this.z;
		var z = cos * this.z + sin * this.y;
		return new Vector3(this.x, y, z);
	}

	rotationY (rotation) {
		if (rotation === 0) {
			// No rotation
			return new Vector3(this.x, this.y, this.z);
		}

		var sin = Math.sin(rotation);
		var cos = Math.cos(rotation);

		var x = cos * this.x + sin * this.z;
		var z = cos * this.z - sin * this.x;
		return new Vector3(x, this.y, z);
	}

	rotationZ (rotation) {
		if (rotation === 0) {
			// No rotation
			return new Vector3(this.x, this.y, this.z);
		}

		var sin = Math.sin(rotation);
		var cos = Math.cos(rotation);

		var x = cos * this.x - sin * this.y;
		var y = cos * this.y + sin * this.x;
		return new Vector3(x, y, this.z);
	}

	unrotationX (rotation) { return this.rotationX(-rotation); }
	unrotationY (rotation) { return this.rotationY(-rotation); }
	unrotationZ (rotation) { return this.rotationZ(-rotation); }

	copy () {
		return new Vector3(this.x, this.y, this.z);
	}

	cross (vec3) {
		var x = this.y * vec3.z - this.z * vec3.y;
		var y = this.z * vec3.x - this.x * vec3.z;
		var z = this.x * vec3.y - this.y * vec3.x;
		return new Vector3(x, y, z);
	}

	length () {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
	}

	dot (vec3) {
		return this.x * vec3.x + this.y * vec3.y + this.z * vec3.z;
	}

	toString () {
		return '[' + this.x + ', ' + this.y + ', ' + this.z + ']';
	}
}

Vector3.prototype.translation = Vector3.prototype.addition;
Vector3.prototype.scaling = Vector3.prototype.multiplication;
Vector3.prototype.translate = Vector3.prototype.add;
Vector3.prototype.scale = Vector3.prototype.multiply;
Vector3.prototype.untranslation = Vector3.prototype.subtraction;
Vector3.prototype.unscaling = Vector3.prototype.division;
Vector3.prototype.untranslate = Vector3.prototype.subtract;
Vector3.prototype.unscale = Vector3.prototype.divide;

// Vector3.lerp = function (t, vec3a, vec3b) {
// 	return new Vector3(
// 		vec3a.x * (1 - t) + vec3b.x * t,
// 		vec3a.y * (1 - t) + vec3b.y * t,
// 		vec3a.z * (1 - t) + vec3b.z * t
// 	);
// };

// Warning: does not always work due to division by 0
// and no check done on colinearity
Vector3.linearCombination = function (vec3a, vec3b, vec3c, result) {
	var xa = vec3a.x;
	var ya = vec3a.y / xa;
	var za = vec3a.z;

	var xb = vec3b.x;
	var yb = vec3b.y;
	var zb = vec3b.z;

	var xc = vec3c.x;
	var yc = vec3c.y;
	var zc = vec3c.z;

	var x = result.x;
	var y = result.y;
	var z = result.z;

	var yba = yb - ya * xc;
	var yca = yc - ya * xc;

	var zba = zb - za * xb;
	var zca = zc - za * xb;

	var c1 = (y - ya * x) / yca;
	var c2 = yba / yca;

	var lc = (z - za * x - zba * c1) / (zca - zba * c2);
	var lb = c1 - lc * c2;
	var la = (x - lc * xc - lb * xb) / xa;

	return new Vector3(la, lb, lc);
};
